import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import VehiclesScreen from '../../screens/Vehicles/VehiclesScreen';
import { supabase } from '../../supabaseClient';

const VehiclesContainer = ({}) => {
  const [data, setData] = useState([]);
  const reloadVehicles = useSelector(
    (state) => state.app.reloadVehicles || false
  );
  const company = useSelector((state) => state.app.company || {});
  const user = useSelector((state) => state.app.user || {});

  useEffect(() => {
    loadData();
  }, [reloadVehicles, company]);

  const loadData = async () => {
    let allData = [];
    let from = 0;
    const pageSize = 1000;
    let hasMore = true;

    while (hasMore) {
      const { data, error } = await supabase
        .from('Vehicle')
        .select('*')
        .is('deleted_at', null)
        .eq('company', company.id)
        .range(from, from + pageSize - 1);

      if (error) {
        console.error('Error loading vehicles:', error);
        break;
      }

      if (data && data.length > 0) {
        allData = [...allData, ...data];
        from += pageSize;
        hasMore = data.length === pageSize;
      } else {
        hasMore = false;
      }
    }

    setData(allData);
  };

  return (
    <VehiclesScreen
      data={data}
      user={user}
      // onRemove={item => swalRemove({ withError: false, functionConfirmRemove: () => onRemove(item) })}
    />
  );
};

export default VehiclesContainer;
